import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';
import * as _ from 'lodash';

@Injectable()
export class ScrollToService {

  // https://github.com/Nolanus/ngx-page-scroll/#pagescroll-properties
  options: any = {
    pageScrollDuration: 500,
    pageScrollOffset: 0,
    pageScrollInterruptible: true,
  };

  constructor(
    @Inject(DOCUMENT) private document: any,
    private scrollService: PageScrollService,
  ) {}

  public init(options: any = {}) {
    Object.assign(this.options, options);
  }

  public scrollTo(options: any) {
    const opts = _.merge({}, this.options, options);
    this.scrollService.scroll(Object.assign({
      document: this.document
    }, this.options, options));
  }
}
